import React from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import './_Technologies.scss';

const technologies = {
    Frontend: ['JavaScript', 'React', 'NextJS', 'React Native'],
    Backend: ['Node.js', 'NestJs', 'ExpressJS', 'Python', 'Django', 'Flask'],
    CMS_Ecommerce: ['Wordpress', 'WooCommerce', 'Shopify'],
    Databases: ['MongoDB', 'SQL', 'GraphQL'],
    DevOps_Cloud: ['AWS', 'Firebase', 'Heroku'],
    AI_ML: ['TensorFlow', 'PyTorch'],
};

const Technologies = () => (
    <Box className="tech-stack" id="technology">
        <Typography variant="h5" className="tech-title">
            Technology Stack
        </Typography>
        {Object.entries(technologies).map(([category, techList]) => (
            <Box key={category} className="tech-category">
                <Typography variant="subtitle1" className="tech-title-alt">
                    {category.replace(/_/g, ' & ')}
                </Typography>
                <Grid container spacing={2}>
                    {techList.map((tech) => (
                        <Grid item xs={6} sm={4} md={3} key={tech}>
                            <Button variant="outlined" className="tech-button" fullWidth>
                                {tech}
                            </Button>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        ))}
    </Box>
);

export default Technologies;
